var cookieContainsPattern = function (pattern) {        
    return ICF.Utils.GetCookie('OptanonConsent').includes(pattern);
};

module.exports = cookieContainsPattern;